import { Component, OnInit, Type, ViewChild } from '@angular/core';
import { FPContentHostDirective } from './fp-content-host.directive';
import { FpDocumentPrintingBase } from './fp-document-printing-base';
import { FPDocumentPrintingService } from './fp-document-printing.service';

@Component({
  selector: 'fp-document-printing',
  templateUrl: './fp-document-printing.component.html',
})
export class FPDocumentPrintingComponent implements OnInit {
  @ViewChild(FPContentHostDirective, { static: true }) contentHost: FPContentHostDirective;

  constructor(
    private fpDocumentPrintingService: FPDocumentPrintingService,
    ) { }

  ngOnInit(): void {
    this.fpDocumentPrintingService.onDocumentChanged().subscribe((eventArgs) => {
      this.loadComponent(eventArgs.Component, eventArgs.Data);
    });
  }

  loadComponent(component: Type<FpDocumentPrintingBase>, data: any) {
    const viewContainerRef = this.contentHost.viewContainerRef;
    viewContainerRef.clear();

    const componentRef = viewContainerRef.createComponent(component);
    componentRef.instance.data = data;
  }
}
